// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app"
import {getAuth} from 'firebase/auth';


const firebaseConfig = {
  apiKey: "AIzaSyBv4GTscFQpaeyef39KttbucpLpVhYc1w8",
  authDomain: "trippy-90e0d.firebaseapp.com",
  projectId: "trippy-90e0d",
  storageBucket: "trippy-90e0d.appspot.com",
  messagingSenderId: "915062603061",
  appId: "1:915062603061:web:a12ff9b50c6eb93e9c607c",
  measurementId: "G-Y9B1FJ88H4"
};


const app = initializeApp(firebaseConfig);


export const auth=getAuth(app);